import React from "react";
import "./TagCloud.css";

const TagCloud = () => {
  return (
    <div className="whatsNew container--full">
      {/* <h3>Tag cloud</h3> */}
      <div className='container'>
        <div className="whatsNew-cloud">
          <p className="item-1">Large Scale Apps</p> 
          <p className="item-2">Performance</p> 
          <p className="item-3">TypeScript</p> 
          <p className="item-4">Node.js</p> 
          <p className="item-5">JavaScript</p> 
          <p className="item-6">Frontend</p> 
          <p className="item-7">Security</p> 
          <p className="item-8">Testing</p> 
          <p className="item-9">Backend</p> 
          <p className="item-10">Large Scale Apps</p> 
          <p className="item-11">Performance</p> 
          <p className="item-12">TypeScript</p> 
          <p className="item-13">Node.js</p> 
          <p className="item-14">JavaScript</p>
          <p className="item-15">Frontend</p>
          <p className="item-16">Security</p> 
          <p className="item-17">Testing</p> 
          <p className="item-18">Backend</p> 
        </div>
      </div>
    </div>
  );
};
export default TagCloud;








